<header class="h-[100vh] w-full relative" transparent-offset>
    <img
        width="1920"
        height="1080"
        loading="lazy"
        ngSrc="/assets/video-placeholder.webp"
        preload="auto"
        alt="We are IN2"
        i18n-alt="@@homeHeroImageAlt"
        loading="lazy"
        class="absolute inset-0 w-full h-full object-cover object-center"
    />

    <video playsinline autoplay loop muted class="absolute inset-0 w-full h-full object-cover object-center" preload="auto" loading="lazy">
        <source src="/assets/bgv.mp4" type="video/mp4" />
        <source src="/assets/bgv.webm" type="video/webm" />
        <span i18n="@@homeVideoFallback">Your browser does not support the video tag.</span>
    </video>

    <div class="absolute inset-0 bg-black opacity-50"></div>
    <div class="absolute h-full w-full">
        <div class="h-full app-container app-container-p relative z-10">
            <div id="we-are">
                <h1 class="text-white text-base md:text-xl" i18n="@@homeHeroTitle">- We are</h1>

                <p class="hero-text" i18n="@@homeHeroTagline">Experts at creating <br />positive behaviour change<br />in rapidly changing <br />environments</p>
            </div>
        </div>
    </div>
</header>

<in2-client-logos></in2-client-logos>
<div class="w-full app-container app-container-p gap-6 py-8">
    <in2-our-capabilities-grid></in2-our-capabilities-grid>
</div>
<in2-case-studies-slider></in2-case-studies-slider>
<section id="in2-market" class="py-8 app-container app-container-p h-full lg:min-h-[500px] xl:min-h-[590px] flex flex-col md:grid md:grid-cols-12">
    <div class="flex flex-col text-center md:text-left">
        <h2 class="heading-2 uppercase text-primary" i18n="@@homeOurOfficesTitle">Our Offices</h2>

        <p class="text-base" i18n="@@homeCompanyDescription">
            IN2 is an innovative, socially responsible, award-winning communications and research company dedicated to driving positive change in hard-to-reach communities,
            particularly in high-risk and rapidly changing environments, such as areas most vulnerable to the climate crisis.
        </p>
    </div>

    <div class="gmap mt-4 md:mt-0">
        <canvas id="map-canvas" class="w-full h-full"></canvas>
        
        <!-- <dotlottie-player [src]="mapSrc()" background="transparent" speed="1" style="width: 100%; height: 100%" direction="1" playMode="normal" autoplay></dotlottie-player> -->
        <!-- <ng-lottie
            [options]="{
                path: '',
                loop: true,
                autoplay: true,
            }"
            width="100%"
            height="100%"
            (animationCreated)="$event.play()"
        /> -->
    </div>
</section>

<!-- !important Do not include this section in production -->
<!-- <section class="py-8 w-full h-full">
    <in2-team-grid></in2-team-grid>
</section> -->

<section class="py-8 bg-white text-black app-container app-container-p w-full h-full flex flex-col items-center">
    <h2 class="heading-2 text-primary pb-6" i18n="@@homeTestimonialsTitle">What our clients say</h2>
    <in2-testimonials-slider class="w-full"></in2-testimonials-slider>
</section>

<section class="py-8 bg-primary text-white">
    <in2-get-in-touch></in2-get-in-touch>
</section>
